import React, { Component } from 'react'
import { connect } from 'react-redux'
import { sendCouponCode, getCouponCodes, updateCouponProp, deleteCoupon} from '../../../actions/Admin'
import AdminDashboardMenu from './AdminDashboardMenu';
import TopNav from '../../includes/TopNav.js';
import { Link } from 'react-router-dom';
import {getUserSession} from '../../../actions/user.js';

class AdminCoupons extends Component {
  constructor(props) {
    super(props);
    this.getUserSession();
  }
  getUserSession(){
    console.log('getting user session');
    this.props.dispatch(getUserSession(ret => {
      if(ret !== false && ret.user.role !== 'admin') {
        window.location.href = "/login";
      } else if(ret === false) {
        window.location.href = "/login";
      }
    }));
  }
  componentDidMount() {
    this.getCouponCodes()
  }
  sendCouponCode() {
    console.log(this.props);
    let temp_body = {
      coupon_code: this.props.Admin.new_coupon_code,
      coupon_amount: this.props.Admin.new_coupon_amount,
      user_email: this.props.Admin.new_coupon_email,
      coupon_counter: this.props.Admin.new_coupon_counter,
      coupon_date: this.props.Admin.new_coupon_date,
      coupon_type: this.props.Admin.new_coupon_type
    }
    this.props.dispatch(sendCouponCode(temp_body, function(){
      this.props.dispatch(getCouponCodes(() => {}))
    }.bind(this)));
    
  }
  getCouponCodes() {
    this.props.dispatch(getCouponCodes(() => {

    }))
  }
  updateCouponProp(key, e){
    console.log(e);
    console.log(key);
    this.props.dispatch(updateCouponProp(key, e.target.value));
    if(key == 'email' && e.target.value != '') {
      if(this.props.Admin.new_coupon_type != 'personal' && this.props.Admin.new_coupon_type != 'abandon') {
        this.props.dispatch(updateCouponProp('type', 'personal'));
      }
    }
  }
  disableCoupon(couponCode) {
    this.props.dispatch(deleteCoupon(couponCode, function(){
      this.props.dispatch(getCouponCodes(() => {}))
    }.bind(this)));
  }
  enableCoupon(couponCode) {
    alert("not yet implemented");
  }
  render() {
    return(
      <div>
        <TopNav />
        <br/><br/>
        <section className="admin-container">
          <AdminDashboardMenu />
          <div className="admin-form">
            <div className="adminAddCoupon">
                <div> Add Coupon Code </div>
                <div>
                  <label>Coupon Code (max 25chars):</label>
                  <input onChange={this.updateCouponProp.bind(this, 'code')} value={this.props.Admin.new_coupon_code}/>
                </div>
                <div>
                  <label>Coupon Type</label>
                  <select onChange={this.updateCouponProp.bind(this,'type')} value={this.props.Admin.new_coupon_type}>
                    <option value="generic">Generic</option>
                    <option value="personal">Personal</option>
                    <option value="abandon">Abandon (dynamic value)</option>
                  </select>
                </div>
                <div>
                  <label>Coupon Amount:</label>
                  <input onChange={this.updateCouponProp.bind(this, 'amount')} type="number" placeholder="Dollar Amount" value={this.props.Admin.new_coupon_amount} />
                </div>
                <div>
                  <label>User Email (if personal):</label>
                  <input onChange={this.updateCouponProp.bind(this, 'email')} type="text" placeholder="email" value={this.props.Admin.new_coupon_email} />
                </div>
                <div>
                  <label>Coupon Counter (only if not personal):</label>
                  <input onChange={this.updateCouponProp.bind(this, 'counter')} type="number" placeholder="" value={this.props.Admin.new_coupon_counter} />
                </div>
                <div>
                  <label>Coupon Expiration:</label>
                  <input onChange={this.updateCouponProp.bind(this, 'date')} type="date" placeholder="" value={this.props.Admin.new_coupon_date} />
                </div>
                <span>
                    <button className="load-more" onClick={this.sendCouponCode.bind(this)}>ADD COUPON</button>
                </span>
              </div>
            </div>
            <div className="adminCouponsList">
              <div className="adminDashboardTabTitle">Coupons</div>
              <div>
                <table className="adminTable">
                  <tbody>
                  <tr>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Code</th>
                    <th>Amount</th>
                    <th>User (if personal)</th>
                    <th>Counter</th>
                    <th>Expiry</th>
                    <th>Actions</th>
                  </tr>
                {this.props.Admin.coupons.map((coupon, i) => {
                  return(
                    <tr key={i}>
                      <td>{(coupon.coupon_valid == 1)? 'Active': 'Disabled'}</td>
                      <td>{(coupon.assigned == 1)? 'Personal': 'Generic'}</td>
                      <td><Link to={"/admindashboard/coupon/"+coupon.coupon_code}>{coupon.coupon_code}</Link></td>
                      <td>{coupon.coupon_amount}</td>
                      <td>{coupon.user_email}</td>
                      <td>{coupon.coupon_counter}</td>
                      <td>{coupon.coupon_date}</td>
                      <td>
                        {(coupon.coupon_valid == 1)?
                          <button onClick={this.disableCoupon.bind(this, coupon.coupon_code)}>Disable</button>
                          :
                          <button onClick={this.enableCoupon.bind(this, coupon.coupon_code)}>Enable</button>
                        }
                      </td>
                    </tr>
                  )
                })}
                  </tbody>
                </table>
              </div>
            </div>
        </section>
      </div>
    )
  }

}

export default connect( ({Dashboard, Admin, AdminDocument, AdminUserCollection}) => ({Dashboard, Admin, AdminDocument, AdminUserCollection}) ) (AdminCoupons)




// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/Coupons.js